interface StatusMessageProps {
  message: string;
  isError: boolean;
}

export function StatusMessage({ message, isError }: StatusMessageProps) {
  if (!message) return null;
  return (
    <div className={isError ? 'reader-status error' : 'reader-status'}>
      {message}
    </div>
  );
}
